<template>
    <div>
        <div class="about_center_top">
            <div class="about_center_text">{{box.boxText}}</div>
            <div class="about_center_bottom" v-show="isShowBot">
                <div class="text">{{box.boxTextWe}}<span>{{box.boxTextEn}}</span></div>
            </div>
            <div class="about_center_bottom leftMove" v-show="isShowBottom">
                <div class="text textMove">
                    
                    <span class="span spanHover" @click="companyNotice">/公司公告</span>
                    <span class="span">/致合作伙伴的一封信</span>
                </div>
            </div>
            <div class="about_center_bottom leftMove" v-show="isShowGao">
                <div class="text textMove">
                    
                    <span class="span spanHover" @click="companyNotice">/公司公告</span>
                    <span class="span">/金控-金逍遥重磅上线</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{}
        },
        props:{
            box:{
                type:Object,
                default:null
            },
            isShowBottom:{
                type:Boolean,
                default:false
            },
            isShowBot:{
                type:Boolean,
                default:true
            },
            isShowGao:{
                type:Boolean,
                default:false
            }
        },
        methods:{
            companyNotice(){
                this.$router.push({
                    path:'/newStatus'
                })
                // this.$emit("companyNotice");
            }
        }
    }
</script>

<style lang="less" scoped>
    .about_center_top{
        width: 100%;
        height: 296px;
        background: url("./img/banne4.png") no-repeat;
        background-size: cover;
        font-size: 44px;
        font-family: "Microsoft YaHei UI";
        .about_center_text{
            text-align: center;
            line-height: 296px;
        }
        .about_center_bottom{
            height: 26px;
            background: #ffffff;
            width: 574px;
            position: absolute;
            top: 321px;
            left: 293px;
            padding: 11px 0 0 11px;
        }
        .text{
            font-size: 12px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #010101;
            span{
                font-size: 7px;
                font-family: "Microsoft YaHei";
                font-weight: 300;
                color: #010101;
                margin-left: 5px;
            }
        }
        .leftMove{
            left: 243px !important;
        }
        .textMove{
            left: 254px !important;
            span{
                font-size: 12px !important;
                font-family: "Microsoft YaHei";
                color: #717171 !important;
            }
            .spanHover:hover{
                font-family: "Microsoft YaHei";
                font-size: 12px !important;
                cursor:pointer;
                color: #000000 !important;
            }
        }
    }
</style>
